import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})

// Footer Component
export class FooterComponent {
  
  version: string = '';
  year: number = new Date().getFullYear();

  constructor() { }

  ngOnInit(): void {
    this.version = environment.version;
  }
}
